<template>
  <div class="publishflow">
    <el-form ref="formData" :rules="rules" :model="formData" label-position="left" size="small">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="标题" prop="title" label-width="80px">
            <el-input v-model.trim="formData.title" size="small" maxlength="30" show-word-limit :disabled="flowStatus">
            </el-input>
            <span slot="error" class="item-error">
              <span>请填写标题</span>
            </span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="flowStatus" :gutter="24">
        <el-col :span="12">
          <el-form-item label="项目名称" prop="prjName" label-width="80px">
            <el-input v-model="formData.prjName" size="small" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目编号" prop="prjCode" label-width="80px">
            <el-input v-model="formData.prjCode" size="small" disabled>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="flowStatus" :gutter="24">
        <el-col :span="12">
          <el-form-item label="申请人" prop="createUserName" label-width="80px">
            <el-input v-model="formData.createUserName" size="small" disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提交时间" prop="createTime" label-width="80px">
            <el-input v-model="formData.createTime" size="small" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="设计阶段" label-width="80px">
            <el-input v-model="formData.designStageName" size="small" maxlength="30" show-word-limit
              :disabled="flowStatus"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="存放目录" prop="targetFolderName" label-width="80px">
            <el-input v-model="formData.targetFolderName" readonly :disabled="flowStatus" size="small" @focus="recelocation" />
            <span slot="error" class="item-error">
              <span>请选择存放目录</span>
            </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="出版专业" prop="publishSpecId" label-width="80px">
            <template v-if="!clientType||startFlowMode===0">
              <el-select v-if="!flowStatus" v-model="formData.publishSpecId" size="small" style="width: 100%"
                clearable filterable :disabled="flowStatus" @change="change_showStartButtons">
                <el-option v-for="item in specList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
              <el-input v-else v-model="formData.publishSpecName" disabled size="small"></el-input>
            </template>
            <template v-else>
              <el-select v-if="!flowStatus" v-model="formData.publishSpecId" size="small" style="width: 100%"
                clearable filterable disabled>
                <el-option v-for="item in specList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
              <el-input v-else v-model="formData.publishSpecName" disabled size="small"></el-input>
            </template>
            <span slot="error" class="item-error">
              <span>请选择出版专业</span>
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联计划" prop="prjPlanId" label-width="80px">
            <el-select v-if="!flowStatus" v-model="formData.prjPlanId" size="small" style="width: 100%" clearable filterable :disabled="flowStatus" @change="changePrjPlan" @focus="focusPrjPlan">
              <el-option v-for="item in prjPlanData" :key="item.taskId" :label="item.taskName" :value="item.taskId" />
            </el-select>
            <el-input v-else v-model="formData.prjPlanName" disabled size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="内容" prop="content" label-width="80px" style="margin-bottom:8px">
            <el-input v-model.trim="formData.content" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea"
              style="width: 100%" maxlength="200" show-word-limit :disabled="flowStatus"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" style="line-height: 20px">
        <el-col :span="24">
          <el-form-item label="出版文件" label-width="80px">
            <div style="display: flex;align-items: baseline;">
              <el-button size="small" :disabled="flowStatus" @click="uploadFolder">
                <i class="el-icon-plus" style="margin-right:5px"></i>关联文件
              </el-button>

              <span style="margin:0px 20px">
                <el-checkbox v-if="formData.isOverwriteSameNameFile === 1" v-model="formData.isOverwriteSameNameFile"
                  :disabled="flowStatus" :true-label="1" :false-label="0">同名文件覆盖
                </el-checkbox>
                <el-checkbox v-else v-model="formData.isOverwriteSameNameFile" :disabled="flowStatus" :true-label="1"
                  :false-label="0">同名文件重命名
                </el-checkbox>
              </span>

              <el-button v-if="flowStatus&&flowStageName=='绑定'" size="small" style="float:right" @click="bindingAll()">
                全部绑定
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 通用关联文件 -->
    <el-dialog v-dialogDrag append-to-body :visible.sync="fileDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      :close="cancel" title="关联文件" width="600px">
      <el-tree ref="localTree" :load="getlocalTree" :data="localTree" :props="defaultFileProps"
        :check-on-click-node="true" :class="[{ activeShowBar: !showBar }]" class="tree" lazy accordion highlight-current
        show-checkbox @check="currentOrgChangeHandlerLocal">
        <template #default="{ data }">
          <span class="treeitem">
            <img v-if="data.isFolder == 0" :src="className(data)" class="img" alt="" />
            <img v-else :src="icon" class="img" alt="" />
            {{ data.folderName }}
          </span>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="fileDialog = false">取消</el-button>
        <el-button type="primary" size="small" @click="filerecelocationBtn">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 存放目录弹框 -->
    <layPlaceDialog ref="layPlaceDialog" @setFileLocation="setFileLocation" />
  </div>
</template>

<script>
import docService from "@/CommonDP/service/doc-service";
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import layPlaceDialog from "./check/checkPlaceDialog.vue";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import { downloadFile, flowFileDownLoad } from "@/CommonDP/utils";
import workProjectBoardService from "@/CommonDP/service/workProjectBoard-service";
export default {
  components: { layPlaceDialog },
  props: {
    // 流程版本号。与 flowKey 两者不可同时为空
    flowDefinitionId: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      viewIcon: require("@/CommonDP/assets/flowIcon/viewIcon.png"),
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      rules: {
        title: [{ required: true, message: "请填写标题", trigger: "blur" }],
        // content: [{ required: true, message: "请填写内容", trigger: "blur" }],
        targetFolderName: [{ required: true, message: "请选择存放目录", trigger: "change" }],
        publishSpecId: [{ required: true, message: "请选择出版专业", trigger: "change" }]
      },
      fileDialog: false,
      defaultFileProps: {
        children: "childList",
        label: "folderName",
        isLeaf: "leaf"
      },
      loading: false,
      node_had: {},
      localTree: [],
      resolve_had: {},
      messageObj: {},
      specList: [],
      readonly: false, // 用以替换 flowStatus
      flowStatus: false,
      formData: {
        title: "",
        isOverwriteSameNameFile: 1,
        targetFolderName: "", // 存放目录
        targetFolderId: "",
        prjPlanId: '',
        prjPlanName: '',
        relationFrameColumnId: ""
      },
      flowStageName: "",
      prjPlanData: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      routerParams: state => state.projectMg.routerParams,
      userInfo: state => state.user.userInfo
    }),
    // cad跳转样式
    showBar() {
      if (window.location.href.indexOf("jsName=BimEx") !== -1) {
        return false;
      } else {
        return true;
      }
    },
    clientType() {
      return Number(this.routerParams.clientType);
    },
    startFlowMode() {
      return Number(this.routerParams.startFlowMode);
    }

  },
  watch: {
    "formData.publishSpecId"(newValue, oldValue) {
      if (newValue) {
        this.getPlanTaskList();
      } else {
        this.formData.prjPlanId = '';
        this.formData.prjPlanName = '';
        this.prjPlanData = [];
      }
    }
  },
  async created() {
    this.formData.relationFrameColumnId = this.$route.query.relationFrameColumnId || '';
    this.formData.approveUserName = this.userInfo.name;
    this.formData.title = this.userInfo.name + "发起" + this.routerParams.name;
    await this.getSpecList();
    await this.$nextTick();
    this.$refs.formData.clearValidate();
  },
  methods: {
    setSpecId(specId) {
      this.$set(this.formData, "publishSpecId", specId);
    },
    // 接口：用于获取表单数据
    getFormData() {
      return this.formData;
    },

    // 接口：设置表单数据
    setFormData(formData) {
      this.formData = formData;
    },
    // 重置表单数据
    resetForm() {
      this.formData.title = this.userInfo.name + "发起" + this.routerParams.name;
      this.formData.isOverwriteSameNameFile = 1;
      this.formData.targetFolderName = "";
      this.formData.targetFolderId = "";
      this.formData.prjPlanId = "";
      this.formData.prjPlanName = "";
      this.formData.relationFrameColumnId = "";
    },

    // 接口：校验表单数据
    validateFormData() {
      let flag = null;
      this.$refs.formData.validate(valid => {
        if (valid) flag = true;
        else flag = false;
      });
      return flag;
    },

    // 打开存放目录弹框
    recelocation() {
      this.$refs.layPlaceDialog.dialogShow = true;
      this.$refs.layPlaceDialog.getFrameTree();
      this.$refs.layPlaceDialog.currentDepartment.folderId = this.formData.targetFolderId;
    },
    // 设置存放目录
    async setFileLocation(obj) {
      const { folderId } = obj;
      this.formData.targetFolderId = folderId;
      const { data } = await workProjectBoardService.getAssociatedFolderLocation(folderId);
      this.formData.targetFolderName = data.map(({ folderName }) => folderName).join("\\");
    },

    // 全部绑定
    bindingAll() {
      this.$emit("bindingAll");
    },
    async getSpecList() {
      const { prjId } = this.routerParams;
      const prjID = prjId || this.prjInfo.prjId;
      const res = await flowService.querySpecList(prjID);
      if (res.data) this.specList = res.data.flowSpecPoList || [];
      if (this.$route.query.major && !this.flowStatus) {
        this.formData.publishSpecId = this.$route.query.major || "";
      }
    },
    async getPlanTaskList() {
      const specId = this.formData.publishSpecId || '';
      const { prjId } = this.routerParams;
      const prjID = prjId || this.prjInfo.prjId;
      const res = await flowService.prjPlanTaskFlowList(this.flowDefinitionId, specId, prjID);
      if (res.data) this.prjPlanData = res.data || [];
    },
    validate() {
      let flag = null;
      this.$refs.formData.validate(valid => {
        if (valid) flag = true;
        else flag = false;
      });
      return flag;
    },
    uploadFolder() {
      const { publishSpecId } = this.formData;
      if (publishSpecId) {
        this.node_had.childNodes = []; // 把存起来的node的子节点清空，不然会界面会出现重复树！
        this.getlocalTree(this.node_had, this.resolve_had); // 再次执行懒加载的方法
        this.fileDialog = true;
      } else {
        this.$message.warning("请先选择出版专业");
      }
    },
    async getlocalTree(node, resolve) {
      console.log(node);
      const { publishSpecId } = this.formData;
      if (node.level === 0) {
        this.node_had = node; // 这里是关键！在data里面定义一个变量，将node.level == 0的node存起来
        this.resolve_had = resolve; // 同上，把node.level == 0的resolve也存起来
        const params = {
          folderId: 0,
          isRead: 1,
          priviAll: "1",
          noRightClickMenu: true,
          prjId: this.prjInfo.prjId || this.routerParams.prjId
        };
        const result = await docService.queryTree(params);
        const list = result.data.filter(({ folderType }) => folderType === 101); // 设计区
        const array = list.map(item => {
          const { childFlag = 0 } = item;
          return {
            isRead: item.isRead,
            priviAll: item.priviAll,
            folderName: item.folderName,
            folderId: item.folderId,
            isFolder: item.isFolder,
            fileType: item.fileType,
            fileVersion: item.fileVersion,
            status: item.status,
            uploadType: 2,
            leaf: childFlag === 0
          };
        });
        return resolve(array);
      } else if (node.level !== undefined) {
        const params = {
          folderId: node.data.folderId,
          isRead: node.data.isRead,
          priviAll: node.data.priviAll,
          noRightClickMenu: true,
          prjId: this.prjInfo.prjId || this.routerParams.prjId
        };
        const res = await docService.queryTree(params);
        const speceList = res.data.filter(({ specId }) => specId === "0" || publishSpecId === specId); // 过滤校审专业
        const listArray = speceList.map(item => {
          const { childFlag = 0 } = item;
          return {
            isRead: item.isRead,
            priviAll: item.priviAll,
            folderName: item.folderName,
            folderId: item.folderId,
            isFolder: item.isFolder,
            fileType: item.fileType,
            fileVersion: item.fileVersion,
            status: item.status,
            leaf: childFlag === 0,
            uploadType: 2
          };
        });

        return resolve(listArray);
      }
    },
    className(row) {
      return tableRowIcon(row);
    },
    async currentOrgChangeHandlerLocal(val, currentChecked) {
      this.currentFileLocal = currentChecked.checkedNodes;
    },
    async filerecelocationBtn() {
      // 对于通用流程关联文档，确定获取文件夹的子级文件
      if (this.currentFileLocal && this.currentFileLocal.length > 0) {
        const list = [];
        // 对于直接选择文件可以先拿出来
        const array = this.currentFileLocal.filter(({ isFolder }) => isFolder === 0);
        const arrayFolder = this.currentFileLocal.filter(({ isFolder }) => isFolder !== 0);
        const array11 = array.map(item => {
          return {
            fileName: item.folderName,
            fileId: item.folderId,
            fileType: item.fileType,
            isFolder: item.isFolder,
            status: item.status,
            versionIds: item.fileVersion,
            uploadType: 2
          };
        });
        // 选中的文件夹点击确定获取子级数据
        for (const item of arrayFolder) {
          const params = {
            folderId: item.folderId,
            isRead: item.isRead,
            priviAll: item.priviAll,
            noRightClickMenu: true,
            prjId: this.prjInfo.prjId || this.routerParams.prjId
          };
          await docService.queryTree(params).then(({ data }) => {
            const listData = data.map(item => {
              return {
                fileName: item.folderName,
                fileId: item.folderId,
                fileType: item.fileType,
                isFolder: item.isFolder,
                status: item.status,
                versionIds: item.fileVersion,
                uploadType: 2
              };
            });
            list.push.apply(list, listData);
          });
        }
        // 将获取到的非文件过滤掉
        const listLocal = list.filter(({ isFolder }) => isFolder === 0);
        // 拼接原来选择的文件
        const floderDatanew = array11.concat(listLocal);
        // 过滤一下重复的
        const res = new Map();
        const floderData = floderDatanew.filter(a => !res.has(a.fileName) && res.set(a.fileName, 1));
        floderData.forEach((ele) => {
          this.$set(ele, 'parentFileId', '');
        });
        this.$emit("tableshow", floderData || []);
      }
      this.fileDialog = false;
    },
    cancel() {
      this.localTree = [];
    },
    // 文件下载
    downLoadFile(row) {
      const fileId = row.fileId;
      const versionIds = row.versionIds;
      const url = flowFileDownLoad(this.routerParams.flowInstanceId, fileId, versionIds);
      downloadFile(url);
    },
    // 切换专业 隐藏发起按钮
    change_showStartButtons() {
      this.$emit("change_showStartButtons");
      this.formData.prjPlanId = '';
      this.formData.prjPlanName = '';
    },
    changePrjPlan(val) {
      if (val) {
        this.formData.prjPlanName = this.prjPlanData.find((ele) => ele.taskId === val).taskName;
      } else {
        this.formData.prjPlanName = "";
      }
    },
    focusPrjPlan() {
      if (!this.formData.publishSpecId) {
        this.$message.warning("请先选择出版专业");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.publishflow{
  overflow: hidden;
  .el-form-item{
    margin-bottom:5px;
    /deep/ .el-form-item__label{
      line-height: 32px;
    }
    /deep/ .el-form-item__content{
      line-height: 13px;
    }
  }
  .item-error{
    display: inline-block;
    color: #F56C6C;
    font-size: 12px;
  }
}
.tree {
  overflow: auto;
  height: 500px;
  max-height: 500px;
  width: 100%;
}
.treeitem {
  display: flex;
  align-items: center;
  user-select: none;
}
.activeShowBar {
  max-height: 300px;
  overflow-y: auto;
}
.img {
  margin-right: 6px;
  height: 16px;
  width: 18px;
  user-select: none;
}
</style>
